import { ApiClient } from '@webapp/core/services/ApiClient'
import { TaxRepository } from './TaxRepository'

export const taxRepository = new TaxRepository({
  httpClient: ApiClient,
})
